import { Component, OnInit } from '@angular/core';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray, ValidatorFn, ValidationErrors } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuizData } from '../QuizData';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
// import { routerNgProbeToken } from '@angular/router/src/router_module';
import { NgbdModalContent } from '../../alert-component';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-motivationquiz',
  templateUrl: './motivationquiz.component.html',
  styleUrls: ['./motivationquiz.component.css']
})
export class MotivationquizComponent {
  form: FormGroup;
  motivs = [];
  whyChange = [];
  whatHappen = [];
  submitted = false;
  score : Number = Number(this.cookie.get("riskScore"));

  constructor(
    private formBuilder: FormBuilder,
    private router : Router,
    private _bkoffService : BackOffServiceService,
    private modalService: NgbModal,
    private cookie : CookieService,
    ) {

  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      motivs: new FormArray([], minSelectedCheckboxes(1)),
      whyChange: new FormArray([], minSelectedCheckboxes(1)),
      habit: ['', [Validators.required, Validators.pattern("^([1-9]|10)$")]],
      whatHappen: new FormArray([], minSelectedCheckboxes(1))
    });


    // async motivs
    // of(this.getMotivs()).subscribe(motivs => {
    //   this.motivs = motivs;
    //   this.addMotivCheckboxes();
    // });
    this.whyChange = this.getwhyChange();
    this.addWhyCheckboxes();

    // synchronous motivs
    this.motivs = this.getMotivs();
    this.addMotivCheckboxes();

    this.whatHappen = this.getWhat();
    this.addWhatCheckboxes();

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });
  }

  private addMotivCheckboxes() {
    this.motivs.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.form.controls.motivs as FormArray).push(control);
    });
  }

  private addWhyCheckboxes() {
    this.whyChange.map((o, j) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.form.controls.whyChange as FormArray).push(control);
    });
  }

  private addWhatCheckboxes() {
    this.whatHappen.map((o, j) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.form.controls.whatHappen as FormArray).push(control);
    });
  }

  get fmBuilder() { return this.form.controls; }

  reset(){
    this.form.reset({PersonalData: new QuizData()});
  }


  getFormControl(name:any) {
    return this.form.get(name);
}

get formData() { return <FormArray>this.form.get('Data'); }


get formMotiv () { return <FormArray>this.form.get('motivs');}
get formwhyChange () { return <FormArray>this.form.get('whyChange');}
get formwhatHappen () { return <FormArray>this.form.get('whatHappen');}
  

  // reset(){
  //   this.form.reset({PersonalData: new QuizData()});
  // }


  getMotivs() {
    return [
      { id: 1, name: 'Healthier weight' },
      { id: 2, name: 'Have more energy' },
      { id: 3, name: 'Have less stress' },
      { id: 4, name: 'Get more sleep' },
      { id: 5, name: 'Eat healthier' },
      { id: 6, name: 'Exercise regularly' },
      { id: 7, name: 'Be more active' },
      { id: 8, name: 'Be less dependant on medicine' },
      { id: 9, name: 'Lower my risk of chronic disease' }
    ];
  }
  getwhyChange() {
    return [
      { id: 1, name: 'I want to look good in my clothes' },
      { id: 2, name: 'I want to make my doctor/partner happy' },
      { id: 3, name: 'I will feel guilty if I do not' },
      { id: 4, name: 'It will be fun to challenge myself' },
      { id: 5, name: 'I want to be healthy' },
      { id: 6, name: 'Not sure' }
    ];
  }

  getWhat() {
    return [
      { id: 1, name: 'Proof that changes impact my health' },
      { id: 2, name: 'Support from family to not sabotage my efforts' },
      { id: 3, name: 'Support from health experts to answer questions' },
      { id: 4, name: 'More time for myself' }
    ];
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.form.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.form.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  submit() {
    if (this.form.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
      return; 
      
    }
    this.submitted = true;
    const selectedMotivs = this.form.value.motivs
      .map((v, i) => v ? this.motivs[i].id : null)
      .filter(v => v !== null);
    console.log('Motives: '+selectedMotivs);

    const selectedWhys = this.form.value.whyChange
      .map((v, j) => v ? this.whyChange[j].id : null)
      .filter(v => v !== null);
    console.log('Whys: '+selectedWhys);

    const habit = Number(this.form.value.habit);
    console.log('habit: '+ habit);

    const selectedWhats = this.form.value.whatHappen
      .map((v, j) => v ? this.whatHappen[j].id : null)
      .filter(v => v !== null);
    console.log('Whys: '+selectedWhats);

    var userMotivInfo = new QuizData();
    userMotivInfo.motiv = selectedMotivs;
    userMotivInfo.whyChange = selectedWhys;
    userMotivInfo.whatHappen = selectedWhats;
    userMotivInfo.habit = habit;

    this._bkoffService.setMotivationQuizData(userMotivInfo);
    this.router.navigateByUrl('/riskscore');
    /*if(this.score < 5){
      this.router.navigateByUrl('/riskScore');
    }else{
      this.router.navigateByUrl('/riskscore');
    }    
    */
  };
}

function minSelectedCheckboxes(min:Number) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected == min ? null : { required: true };
  };

  return validator;
  
}
